module.exports = __webpack_public_path__ + "img/receipt.e22ca868.svg";